export default __webpack_public_path__ + "static/media/slider.02faa934.png";